import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../layout/Footer";
import { AuthContext } from "../context/AuthContext";
import AppHeader from "./AppHeader";

const Layout = (props) => {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  const hideFooterRoutes = [
    "/tools/beyondstay-checkout",
    "/tools/beyond-stay",
    "/tools/beyond-ease",
    "/tools/beyond-concierge",
    "/tools/beyond-calendar",
    "/tools/beyond-mail",
  ];

  const shouldHideFooter = hideFooterRoutes.includes(location.pathname);

  const isPublicRoute =
    location.pathname === "/" ||
    location.pathname.startsWith("/best-hotels/") ||
    location.pathname.startsWith("/page/") ||
    location.pathname.startsWith("/tools/") ||
    [
      "/about-us",
      "/career",
      "/features",
      "/contact-us",
      "/pricing",
      "/pricing-details",
      "/clients",
      "/sales",
      "/review-management",
      "/channel-manager",
      "/marketing",
      "/recruiting",
      "/lead-enrichment",
      "/data-to-lead",
      "/linkedin-extension",
      "/hospitality",
      "/data-outreach",
      "/finance",
      "/privacy-policy",
      "/security-policy",
      "/terms-and-conditions",
      "/product-comparison",
      "/technology",
      "/what-we-offer",
      "/faq",
    ].includes(location.pathname);

  return (
    <>
      <AppHeader />
      <div id="home" className={!isAuthenticated && "no-login"}>
        {props?.children}
      </div>
      {/* {isAuthenticated ? "" : <Footer />} */}
      {(!isAuthenticated || isPublicRoute) && !shouldHideFooter && <Footer />}
    </>
  );
};

export default Layout;
